import React from "react";
import "./App.css";
import CourseSection from './CourseSection';
import StatsSection from './StatsSection';
import AboutSection from './AboutSection';
import Footer from './Footer';
import HeaderHero from "./HeaderHero";
import ContributeSection from "./ContributeSection";
import SemguruSection from "./SemguruSection";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useEffect, useState } from "react";
//import ReactGA from "react-ga4";
import CAOModules from "./CAOModules";
import DEModules from "./DEModules";
import OOPSModules from "./OOPSModules";
import DAAModules from "./DAAModules";
import TOCModules from "./TOCModules";
import MPMCModules from "./MPMCModules";
import CoursesPage from "./CoursesPage";
import BEEEModules from './BEEEModules';
import ChemistryModules from './ChemistryModules';
import CalculusModules from './CalculusModules';
import DMModules from './DMModules';
import CVLAModules from './CVLAModules';
import DSDModules from './DSDModules';
import CNModules from './CNModules';
import DBMSModules from './DBMSModules';
import OSModules from './OSModules';
import AIModules from './AIModules';
import CDModules from './CDModules';
import DSAModules from './DSAModules'
import SEModules from './SEModules';
import CNSModules from './CNSModules';
import ESModules from './ESModules';


// DAA imports 
import DAAM1S1 from "./subjects/DAA/Module1/m1s1";
import DAAM1S2 from "./subjects/DAA/Module1/m1s2";
import DAAM1S3 from "./subjects/DAA/Module1/m1s3";
import DAAM1S4 from "./subjects/DAA/Module1/m1s4";
import DAAM1S5 from "./subjects/DAA/Module1/m1s5";

import DAAM2S1 from "./subjects/DAA/Module2/m2s1";
import DAAM2S2 from "./subjects/DAA/Module2/m2s2";
import DAAM2S3 from "./subjects/DAA/Module2/m2s3";
import DAAM2S4 from "./subjects/DAA/Module2/m2s4";
import DAAM2S5 from "./subjects/DAA/Module2/m2s5";
import DAAM2S6 from "./subjects/DAA/Module2/m2s6";
import DAAM2S7 from "./subjects/DAA/Module2/m2s7";
import DAAM2S8 from "./subjects/DAA/Module2/m2s8";
import DAAM2S9 from "./subjects/DAA/Module2/m2s9";

import DAAM3S1 from "./subjects/DAA/Module3/m3s1";
import DAAM3S2 from "./subjects/DAA/Module3/m3s2";
import DAAM3S3 from "./subjects/DAA/Module3/m3s3";

import DAAM4S1 from "./subjects/DAA/Module4/m4s1";
import DAAM4S2 from "./subjects/DAA/Module4/m4s2";
import DAAM4S3 from "./subjects/DAA/Module4/m4s3";
import DAAM4S4 from "./subjects/DAA/Module4/m4s4";
import DAAM4S5 from "./subjects/DAA/Module4/m4s5";

import DAAM5S1 from "./subjects/DAA/Module5/m5s1";
import DAAM5S2 from "./subjects/DAA/Module5/m5s2";
import DAAM5S3 from "./subjects/DAA/Module5/m5s3";

import DAAM6S1 from "./subjects/DAA/Module6/m6s1";
import DAAM6S2 from "./subjects/DAA/Module6/m6s2";
import DAAM6S3 from "./subjects/DAA/Module6/m6s3";



// TOC imports
import { ModuleSubtopicProofTechniques } from "./subjects/TOC/Module1/ProofTechniques"; // Named import
import { ModuleSubtopicLanguagesGrammar } from "./subjects/TOC/Module1/LangugesGrammar"; // Named import
import { ModuleSubtopicAlphabetsStrings } from "./subjects/TOC/Module1/AlpahbetsStringsOperation"; // Named import
import { ModuleSummaryTOC } from "./subjects/TOC/Module1/Summary";
import { ModuleSubtopicFiniteAutomata } from "./subjects/TOC/Module2/Finiteautomata";
import { ModuleSubtopicNFA } from "./subjects/TOC/Module2/NFA";
import { ModuleSubtopicDFA } from "./subjects/TOC/Module2/DFA";
import { ModuleSubtopicNFAConversion } from "./subjects/TOC/Module2/NFAConversion";
import { ModuleSubtopicNFAtoDFA } from "./subjects/TOC/Module2/NFAtoDFA";
import { ModuleSubtopicMinimizationDFA } from "./subjects/TOC/Module2/MinimizationDFA";
import { ModuleSummary2TOC } from "./subjects/TOC/Module2/ModuleSummary";
import { ModuleSubtopicRegularExpressions } from "./subjects/TOC/Module3/RegularExpressions";
import { ModuleSubtopicFAtoRE } from "./subjects/TOC/Module3/FAtoRE";
import { ModuleSubtopicREtoFA } from "./subjects/TOC/Module3/REtoFA";
import { ModuleSubtopicPumpingLemma } from "./subjects/TOC/Module3/PumpingLemma";
import { ModuleSubtopicCFG } from "./subjects/TOC/Module4/CFG";
import { ModuleSubtopicDerivations } from "./subjects/TOC/Module4/Derivations";
import { ModuleSubtopicCYK } from "./subjects/TOC/Module4/CYK";
import { ModuleSubtopicSimplificationCFG } from "./subjects/TOC/Module4/SimplificationCFG";
import { ModuleSubtopicNormalFormsCFG } from "./subjects/TOC/Module4/NormalFormsCFG";
import { ModuleSubtopicPumpingLemmaCFL } from "./subjects/TOC/Module4/PumpingLemmaCFL";
import { ModuleSubtopicClosurePropertiesCFL } from "./subjects/TOC/Module4/ClosurePropertiesCFL";
import { ModuleSubtopicPDA } from "./subjects/TOC/Module5/PDA";
//import TOCM5S1 from "./subjects/TOC/Module5/NPDADPDA";




// OOPS imports
import OOPM1S1 from "./subjects/OOPS/Module1/m1s1";
import OOPM1S2 from "./subjects/OOPS/Module1/m1s2";
import OOPM1S3 from "./subjects/OOPS/Module1/m1s3";
import OOPM1S4 from "./subjects/OOPS/Module1/m1s4";
import OOPM1S5 from "./subjects/OOPS/Module1/m1s5";
import OOPM1S6 from "./subjects/OOPS/Module1/m1s6";
import OOPM1S7 from "./subjects/OOPS/Module1/m1s7";
import OOPM1S8 from "./subjects/OOPS/Module1/m1s8";

import OOPM2S1 from "./subjects/OOPS/Module2/m2s1";
import OOPM2S2 from "./subjects/OOPS/Module2/m2s2";
import OOPM2S3 from "./subjects/OOPS/Module2/m2s3";
import OOPM2S4 from "./subjects/OOPS/Module2/m2s4";
import OOPM2S5 from "./subjects/OOPS/Module2/m2s5";

import OOPM3S1 from "./subjects/OOPS/Module3/m3s1";
import OOPM3S2 from "./subjects/OOPS/Module3/m3s2";
import OOPM3S3 from "./subjects/OOPS/Module3/m3s3";
import OOPM3S4 from "./subjects/OOPS/Module3/m3s4";
import OOPM3S5 from "./subjects/OOPS/Module3/m3s5";

import OOPM4S1 from "./subjects/OOPS/Module4/m4s1";

import OOPM5S1 from "./subjects/OOPS/Module5/m5s1";
import OOPM5S2 from "./subjects/OOPS/Module5/m5s2";
import OOPM5S3 from "./subjects/OOPS/Module5/m5s3";
import OOPM5S4 from "./subjects/OOPS/Module5/m5s4";
import OOPM5S5 from "./subjects/OOPS/Module5/m5s5";
import OOPM5S6 from "./subjects/OOPS/Module5/m5s6";
import OOPM5S7 from "./subjects/OOPS/Module5/m5s7";

import OOPM6S1 from "./subjects/OOPS/Module6/m6s1";

import OOPM7S1 from "./subjects/OOPS/Module7/m7s1";
import OOPM7S2 from "./subjects/OOPS/Module7/m7s2";
import OOPM7S3 from "./subjects/OOPS/Module7/m7s3";

import OOPM8S1 from "./subjects/OOPS/Module8/m8s1";
import OOPM8S2 from "./subjects/OOPS/Module8/m8s2";

//MPMC 
import MPMCM1S1 from "./subjects/MPMC/Module1/m1s1";

import MPMCM3S1 from "./subjects/MPMC/Module3/m3s1";
import MPMCM3S2 from "./subjects/MPMC/Module3/m3s2";
import MPMCM3S3 from "./subjects/MPMC/Module3/m3s3";
import MPMCM3S4 from "./subjects/MPMC/Module3/m3s4";
import MPMCM3S5 from "./subjects/MPMC/Module3/m3s5";
import MPMCM3S6 from "./subjects/MPMC/Module3/m3s6";
import MPMCM3S7 from "./subjects/MPMC/Module3/m3s7";
import MPMCM3S8 from "./subjects/MPMC/Module3/m3s8";
import MPMCM3S9 from "./subjects/MPMC/Module3/m3s9";

import MPMCM4S1 from "./subjects/MPMC/Module4/m4s1";
import MPMCM4S2 from "./subjects/MPMC/Module4/m4s2";
import MPMCM4S3 from "./subjects/MPMC/Module4/m4s3";
import MPMCM4S4 from "./subjects/MPMC/Module4/m4s4";

import MPMCM5S1 from "./subjects/MPMC/Module5/m5s1";
import MPMCM5S2 from "./subjects/MPMC/Module5/m5s2";
import MPMCM5S3 from "./subjects/MPMC/Module5/m5s3";
import MPMCM5S4 from "./subjects/MPMC/Module5/m5s4";

import MPMCM6S1 from "./subjects/MPMC/Module6/m6s1";
import MPMCM7S1 from "./subjects/MPMC/Module7/m7s1";



//DE imports 
//M1
import M1S1 from "./subjects/DifferentialEquations/Module1/Order_and_Degree";
import M1S2 from "./subjects/DifferentialEquations/Module1/methodofundeterminedcoefficients";
import M1S3 from "./subjects/DifferentialEquations/Module1/methodofvariationofparameters";
import M1S4 from "./subjects/DifferentialEquations/Module1/Homogenous equationofCauchyEuler’stype ";
import M1S5 from "./subjects/DifferentialEquations/Module1/SolvingDEinMechanical&ElectricalCircuits ";
import M1S6 from "./subjects/DifferentialEquations/Module1/Summary";
//M2
import M2S1 from "./subjects/DifferentialEquations/Module2/formationofpde";
import M2S2 from "./subjects/DifferentialEquations/Module2/Solvinglinearpde";
import M2S3 from "./subjects/DifferentialEquations/Module2/Solvingnon-linearpde";
import M2S4 from "./subjects/DifferentialEquations/Module2/Methodofseparationofvariables";
import M2S5 from "./subjects/DifferentialEquations/Module2/Summary";
//M3
import M3S1 from "./subjects/DifferentialEquations/Module3/laplacetransform";
import M3S2 from "./subjects/DifferentialEquations/Module3/propertiesoflaplacetransform";
import M3S3 from "./subjects/DifferentialEquations/Module3/laplaceofperiodicfunctions";
import M3S4 from "./subjects/DifferentialEquations/Module3/inverselaplacetransform";
import M3S5 from "./subjects/DifferentialEquations/Module3/Summary";
//M4
import M4S1 from "./subjects/DifferentialEquations/Module4/Solvingodeusinglaplace";
import M4S2 from "./subjects/DifferentialEquations/Module4/Solvingpdeusinglaplace";
import M4S3 from "./subjects/DifferentialEquations/Module4/Summary";
//M5
import M5S1 from "./subjects/DifferentialEquations/Module5/Fourierforperiodicfunctions";
import M5S2 from "./subjects/DifferentialEquations/Module5/Fourierforevenandoddfunction";
import M5S3 from "./subjects/DifferentialEquations/Module5/FourierHalfrangesineandcosineseries";
import M5S4 from "./subjects/DifferentialEquations/Module5/parseval's_identity _fourier_series";
import M5S5 from "./subjects/DifferentialEquations/Module5/Summary";
//M6
import M6S1 from "./subjects/DifferentialEquations/Module6/Fourier_transform";
import M6S2 from "./subjects/DifferentialEquations/Module6/Properties";
import M6S3 from "./subjects/DifferentialEquations/Module6/fourier_convoultion";
import M6S4 from "./subjects/DifferentialEquations/Module6/fourier_sine_cosine";
import M6S5 from "./subjects/DifferentialEquations/Module6/fourier_parseval";
import M6S6 from "./subjects/DifferentialEquations/Module6/fourier_appl";
//M7
import M7S1 from "./subjects/DifferentialEquations/Module7/Z-transform";
import M7S2 from "./subjects/DifferentialEquations/Module7/z_properties";
import M7S3 from "./subjects/DifferentialEquations/Module7/z_inverse";
import M7S4 from "./subjects/DifferentialEquations/Module7/difference";



//CAO imports
//M1
import M1s1 from "./subjects/CAO/Module1/Functional_components_of_comp";
import M1s2 from "./subjects/CAO/Module1/Register_and_it's_files";
import M1s3 from "./subjects/CAO/Module1/Interconnection_of_components"
import M1s4 from "./subjects/CAO/Module1/IAS computer function";
import M1s5 from "./subjects/CAO/Module1/VON Neumann Machine and Harvard Architecture";
import M1s6 from "./subjects/CAO/Module1/CISC and RISC Architectures";
import M1s7 from "./subjects/CAO/Module1/Summary";
//M2
import M2s1 from "./subjects/CAO/Module2/Multiplication_of_binary";
import M2s2 from "./subjects/CAO/Module2/Division_of_binary";
import M2s3 from "./subjects/CAO/Module2/floating_point";
import M2s4 from "./subjects/CAO/Module2/Summary";
//M3
import M3s1 from "./subjects/CAO/Module3/Types of Instructions";
import { ModuleSubtopicMemoryTraffic } from "./subjects/CAO/Module3/CAO_M3_memorytraffic";
import M3s3 from "./subjects/CAO/Module3/Addressing Modes";
import M3s4 from "./subjects/CAO/Module3/Phases of Instruction Cycle";
import M3s5 from "./subjects/CAO/Module3/Datapath and control unit";
import M3s6 from "./subjects/CAO/Module3/Performance metrics";
import M3s7 from "./subjects/CAO/Module3/Summary";
//M4
import M4s1 from "./subjects/CAO/Module4/Memory Hierarchy";
import M4s2 from "./subjects/CAO/Module4/Byte storage methods";
import M4s3 from "./subjects/CAO/Module4/Conceptual view of memory cell";
import M4s4 from "./subjects/CAO/Module4/Memory Interleaving";
import { ModuleSubtopicCacheManagement } from "./subjects/CAO/Module4/CAO_M4_cachemanagement";
import M4s6 from "./subjects/CAO/Module4/Summary";
//M5
import M5s1 from "./subjects/CAO/Module5/I&o fundamentals";
import M5s2 from "./subjects/CAO/Module5/Programmed I&O";
import M5s3 from "./subjects/CAO/Module5/Interrupt driven I&O";
import M5s4 from "./subjects/CAO/Module5/DMA";
import M5s5 from "./subjects/CAO/Module5/Interrupt structures";
import M5s6 from "./subjects/CAO/Module5/Buses";
import M5s7 from "./subjects/CAO/Module5/Summary";
//M6
import M6s1 from "./subjects/CAO/Module6/Solid state drivers";
import M6s2 from "./subjects/CAO/Module6/Electronic";
import M6s3 from "./subjects/CAO/Module6/RAID";
import M6s4 from "./subjects/CAO/Module6/Summary";
//M7
import M7s1 from "./subjects/CAO/Module7/Classification of model";
import M7s2 from "./subjects/CAO/Module7/Pipelining";
import M7s3 from "./subjects/CAO/Module7/Hazards";
import M7s4 from "./subjects/CAO/Module7/Superscalar architecture";
import M7s5 from "./subjects/CAO/Module7/performance evaluation";

//CD imports
import CDM1S1 from "./subjects/COMPILER/Module1/m1s1";
import CDM1S2 from "./subjects/COMPILER/Module1/m1s2";
import CDM1S3 from "./subjects/COMPILER/Module1/m1s3";
import CDM1S4 from "./subjects/COMPILER/Module1/m1s4";
import CDM2S1 from "./subjects/COMPILER/Module2/m2s1";
import CDM2S2 from "./subjects/COMPILER/Module2/m2s2";
import CDM2S3 from "./subjects/COMPILER/Module2/m2s3";
import CDM2S4 from "./subjects/COMPILER/Module2/m2s4";
import CDM2S5 from "./subjects/COMPILER/Module2/m2s5";
import CDM2S6 from "./subjects/COMPILER/Module2/m2s6";
import CDM2S7 from "./subjects/COMPILER/Module2/m2s7";
import CDM2S8 from "./subjects/COMPILER/Module2/m2s8";
import CDM2S9 from "./subjects/COMPILER/Module2/m2s9";
import CDM3S1 from "./subjects/COMPILER/Module3/m3s1";
import CDM3S2 from "./subjects/COMPILER/Module3/m3s2";
import CDM4S1 from "./subjects/COMPILER/Module4/m4s1";
import CDM4S2 from "./subjects/COMPILER/Module4/m4s2";
import CDM5S1 from "./subjects/COMPILER/Module5/m5s1";
import CDM5S2 from "./subjects/COMPILER/Module5/m5s2";
import CDM5S3 from "./subjects/COMPILER/Module5/m5s3";
import CDM6S1 from "./subjects/COMPILER/Module6/m6s1";
import CDM6S2 from "./subjects/COMPILER/Module6/m6s2";
import CDM6S3 from "./subjects/COMPILER/Module6/m6s3";
import CDM6S4 from "./subjects/COMPILER/Module6/m6s4";
import CDM7S1 from "./subjects/COMPILER/Module7/m7s1";
import CDM7S2 from "./subjects/COMPILER/Module7/m7s2";

//CH imports
import CHM1S1 from "./subjects/Chemistry/Module1/m1s1";
import CHM1S2 from "./subjects/Chemistry/Module1/m1s2";
import CHM1S3 from "./subjects/Chemistry/Module1/m1s3";
import CHM2S1 from "./subjects/Chemistry/Module2/m2s1";
import CHM2S2 from "./subjects/Chemistry/Module2/m2s2";
import CHM3S1 from "./subjects/Chemistry/Module3/m3s1";
import CHM3S2 from "./subjects/Chemistry/Module3/m3s2";
import CHM4S1 from "./subjects/Chemistry/Module4/m4s1";
import CHM4S2 from "./subjects/Chemistry/Module4/m4s2";
import CHM5S1 from "./subjects/Chemistry/Module5/m5s1";
import CHM5S2 from "./subjects/Chemistry/Module5/m5s2";
import CHM6S1 from "./subjects/Chemistry/Module6/m6s1";
import CHM7S1 from "./subjects/Chemistry/Module7/m7s1";
import CHM7S2 from "./subjects/Chemistry/Module7/m7s2";
import CHM7S3 from "./subjects/Chemistry/Module7/m7s3";

//AI imports
import AIM1S1 from "./subjects/AI/Module1/m1s1";
import AIM1S2 from "./subjects/AI/Module1/m1s2";
import AIM1S3 from "./subjects/AI/Module1/m1s3";
import AIM2S1 from "./subjects/AI/Module2/m2s1";
import AIM2S2 from "./subjects/AI/Module2/m2s2";
import AIM2S3 from "./subjects/AI/Module2/m2s3";
import AIM3S1 from "./subjects/AI/Module3/m3s1";
import AIM3S2 from "./subjects/AI/Module3/m3s2";
import AIM3S3 from "./subjects/AI/Module3/m3s3";
import AIM4S1 from "./subjects/AI/Module4/m4s1";
import AIM4S2 from "./subjects/AI/Module4/m4s2";
import AIM4S3 from "./subjects/AI/Module4/m4s3";
import AIM5S1 from "./subjects/AI/Module5/m5s1";
import AIM5S2 from "./subjects/AI/Module5/m5s2";
import AIM6S1 from "./subjects/AI/Module6/m6s1";
import AIM6S2 from "./subjects/AI/Module6/m6s2";
import AIM6S3 from "./subjects/AI/Module6/m6s3";
import AIM6S4 from "./subjects/AI/Module6/m6s4";
import AIM7S1 from "./subjects/AI/Module7/m7s1";
import AIM7S2 from "./subjects/AI/Module7/m7s2";
import AIM7S3 from "./subjects/AI/Module7/m7s3";

//DSD imports
import DSDM1S1 from "./subjects/DSD/Module1/m1s1";
import DSDM1S2 from "./subjects/DSD/Module1/m1s2";
import DSDM1S3 from "./subjects/DSD/Module1/m1s3";
import DSDM1S4 from "./subjects/DSD/Module1/m1s4";
import DSDM1S5 from "./subjects/DSD/Module1/m1s5";
import DSDM2S1 from "./subjects/DSD/Module2/m2s1";
import DSDM3S1 from "./subjects/DSD/Module3/m3s1";
import DSDM3S2 from "./subjects/DSD/Module3/m3s2";
import DSDM3S3 from "./subjects/DSD/Module3/m3s3";
import DSDM3S4 from "./subjects/DSD/Module3/m3s4";
import DSDMCS1 from "./subjects/DSD/Cat2/mcs1";
import DSDMCS2 from "./subjects/DSD/Cat2/mcs2";
import DSDMCS3 from "./subjects/DSD/Cat2/mcs3";
import DSDMCS4 from "./subjects/DSD/Cat2/mcs4";
import DSDMCS5 from "./subjects/DSD/Cat2/mcs5";
import DSDMCS6 from "./subjects/DSD/Cat2/mcs6";
import DSDMCS7 from "./subjects/DSD/Cat2/mcs7";
import DSDMCS8 from "./subjects/DSD/Cat2/mcs8";
import DSDMCS9 from "./subjects/DSD/Cat2/mcs9";
import DSDM6S1 from "./subjects/DSD/Module6/m6s1";
import DSDM7S1 from "./subjects/DSD/Module7/m7s1";


//BEEE imports
import BEEEM1S1 from "./subjects/BEEE/Module1/m1s1";
import BEEEM1S2 from "./subjects/BEEE/Module1/m1s2";
import BEEEM1S3 from "./subjects/BEEE/Module1/m1s3";
import BEEEM2S1 from "./subjects/BEEE/Module2/m2s1";
import BEEEM3S1 from "./subjects/BEEE/Module3/m3s1";
import BEEEM3S2 from "./subjects/BEEE/Module3/m3s2";
import BEEEM4S1 from "./subjects/BEEE/Module4/m4s1";
import BEEEM5S1 from "./subjects/BEEE/Module5/m5s1";
import BEEEM5S2 from "./subjects/BEEE/Module5/m5s2";
import BEEEM6S1 from "./subjects/BEEE/Module6/m6s1";

//Calculus imports
import CALM1S1 from "./subjects/Calculus/Module1/m1s1";
import CALM1S2 from "./subjects/Calculus/Module1/m1s2";
import CALM1S3 from "./subjects/Calculus/Module1/m1s3";

import CALM2S1 from "./subjects/Calculus/Module2/m2s1";
import CALM2S2 from "./subjects/Calculus/Module2/m2s2";
import CALM2S3 from "./subjects/Calculus/Module2/m2s3";

import CALM3S1 from "./subjects/Calculus/Module3/m3s1";
import CALM3S2 from "./subjects/Calculus/Module3/m3s2";
import CALM3S3 from "./subjects/Calculus/Module3/m3s3";

import CALM4S1 from "./subjects/Calculus/Module4/m4s1";
import CALM4S2 from "./subjects/Calculus/Module4/m4s2";
import CALM4S3 from "./subjects/Calculus/Module4/m4s3";
import CALM4S4 from "./subjects/Calculus/Module4/m4s4";
import CALM4S5 from "./subjects/Calculus/Module4/m4s5";
import CALM4S6 from "./subjects/Calculus/Module4/m4s6";

import CALM5S1 from "./subjects/Calculus/Module5/m5s1";
import CALM5S2 from "./subjects/Calculus/Module5/m5s2";
import CALM5S3 from "./subjects/Calculus/Module5/m5s3";

import CALM6S1 from "./subjects/Calculus/Module6/m6s1";
import CALM6S2 from "./subjects/Calculus/Module6/m6s2";
import CALM6S3 from "./subjects/Calculus/Module6/m6s3";
import CALM6S4 from "./subjects/Calculus/Module6/m6s4";

import CALM7S1 from "./subjects/Calculus/Module7/m7s1";
import CALM7S2 from "./subjects/Calculus/Module7/m7s2";
import CALM7S3 from "./subjects/Calculus/Module7/m7s3";
import CALM7S4 from "./subjects/Calculus/Module7/m7s4";
import CALM7S5 from "./subjects/Calculus/Module7/m7s5";

//DM imports
import DM1S1 from "./subjects/DM/Module1/m1s1";
import DM1S2 from "./subjects/DM/Module1/m1s2";
import DM1S3 from "./subjects/DM/Module1/m1s3";
import DM2S1 from "./subjects/DM/Module2/m2s1";
import DM3S1 from "./subjects/DM/Module3/m3s1";
import DM3S2 from "./subjects/DM/Module3/m3s2";
import DM3S3 from "./subjects/DM/Module3/m3s3";
import DM3S4 from "./subjects/DM/Module3/m3s4";

import DM4S1 from "./subjects/DM/Module4/m4s1";
import DM4S2 from "./subjects/DM/Module4/m4s2";
import DM4S3 from "./subjects/DM/Module4/m4s3";
import DM4S4 from "./subjects/DM/Module4/m4s4";
import DM5S1 from "./subjects/DM/Module5/m5s1";
import DM5S2 from "./subjects/DM/Module5/m5s2";
import DM5S3 from "./subjects/DM/Module5/m5s3";
import DM5S4 from "./subjects/DM/Module5/m5s4";
import DM5S5 from "./subjects/DM/Module5/m5s5";
import DM5S6 from "./subjects/DM/Module5/m5s6";

import DM6S1 from "./subjects/DM/Module6/m6s1";
import DM6S2 from "./subjects/DM/Module6/m6s2";
import DM6S3 from "./subjects/DM/Module6/m6s3";

import DM7S1 from "./subjects/DM/Module7/m7s1";


//DSA imports
import DSAM1S1 from "./subjects/DSA/Module1/m1s1";
import DSAM1S2 from "./subjects/DSA/Module1/m1s2";
import DSAM1S3 from "./subjects/DSA/Module1/m1s3";
import DSAM1S4 from "./subjects/DSA/Module1/m1s4";
import DSAM1S5 from "./subjects/DSA/Module1/m1s5";

import DSAM2S1 from "./subjects/DSA/Module2/m2s1";
import DSAM2S2 from "./subjects/DSA/Module2/m2s2";
import DSAM2S3 from "./subjects/DSA/Module2/m2s3";
import DSAM2S4 from "./subjects/DSA/Module2/m2s4";
import DSAM2S5 from "./subjects/DSA/Module2/m2s5";

import DSAM3S1 from "./subjects/DSA/Module3/m3s1";
import DSAM3S2 from "./subjects/DSA/Module3/m3s2";
import DSAM3S3 from "./subjects/DSA/Module3/m3s3";
import DSAM3S4 from "./subjects/DSA/Module3/m3s4";
import DSAM3S5 from "./subjects/DSA/Module3/m3s5";
import DSAM4S1 from "./subjects/DSA/Module4/m4s1";
import DSAM4S2 from "./subjects/DSA/Module4/m4s2";

import DSAM5S1 from "./subjects/DSA/Module5/m5s1";
import DSAM5S2 from "./subjects/DSA/Module5/m5s2";

import DSAM6S1 from "./subjects/DSA/Module6/m6s1";
import DSAM6S2 from "./subjects/DSA/Module6/m6s2";
import DSAM7S1 from "./subjects/DSA/Module7/m7s1";



//CVLA imports
import CVLAM1S1 from "./subjects/CVLA/Module1/m1s1";
import CVLAM1S2 from "./subjects/CVLA/Module1/m1s2";
import CVLAM1S3 from "./subjects/CVLA/Module1/m1s3";
import CVLAM1S4 from "./subjects/CVLA/Module1/m1s4";
import CVLAM1S5 from "./subjects/CVLA/Module1/m1s5";
import CVLAM2S1 from "./subjects/CVLA/Module2/m2s1";
import CVLAM2S2 from "./subjects/CVLA/Module2/m2s2";
import CVLAM2S3 from "./subjects/CVLA/Module2/m2s3";
import CVLAM3S1 from "./subjects/CVLA/Module3/m3s1";
import CVLAM3S2 from "./subjects/CVLA/Module3/m3s2";
import CVLAM3S3 from "./subjects/CVLA/Module3/m3s3";
import CVLAM3S4 from "./subjects/CVLA/Module3/m3s4";
import CVLAM3S5 from "./subjects/CVLA/Module3/m3s5";
import CVLAM3S6 from "./subjects/CVLA/Module3/m3s6";
import CVLAM4S1 from "./subjects/CVLA/Module4/m4s1";
import CVLAM4S2 from "./subjects/CVLA/Module4/m4s2";
import CVLAM7S1 from "./subjects/CVLA/Module7/m7s1";
import CVLAM7S2 from "./subjects/CVLA/Module7/m7s2";
import CVLAM7S3 from "./subjects/CVLA/Module7/m7s3";
import CVLAM5S1 from "./subjects/CVLA/Module5/m5s1";
import CVLAM5S2 from "./subjects/CVLA/Module5/m5s2";
import CVLAM5S3 from "./subjects/CVLA/Module5/m5s3";
import CVLAM6S1 from "./subjects/CVLA/Module6/m6s1";




//DBMS imports
import DBMSM1S1 from "./subjects/DBMS/Module1/m1s1";

import DBMSM2S1 from "./subjects/DBMS/Module2/m2s1";
import DBMSM2S2 from "./subjects/DBMS/Module2/m2s2";
import DBMSM2S3 from "./subjects/DBMS/Module2/m2s3";
import DBMSM2S4 from "./subjects/DBMS/Module2/m2s4";

import DBMSM3S1 from "./subjects/DBMS/Module3/m3s1";
import DBMSM3S2 from "./subjects/DBMS/Module3/m3s2";
import DBMSM3S3 from "./subjects/DBMS/Module3/m3s3";
import DBMSM4S1 from "./subjects/DBMS/Module4/m4s1";
import DBMSM4S2 from "./subjects/DBMS/Module4/m4s2";
import DBMSM4S3 from "./subjects/DBMS/Module4/m4s3";
import DBMSM4S4 from "./subjects/DBMS/Module4/m4s4";
import DBMSM4S5 from "./subjects/DBMS/Module4/m4s5";
import DBMSM5S1 from "./subjects/DBMS/Module5/m5s1";
import DBMSM5S2 from "./subjects/DBMS/Module5/m5s2";
import DBMSM5S3 from "./subjects/DBMS/Module5/m5s3";
import DBMSM5S4 from "./subjects/DBMS/Module5/m5s4";
import DBMSM6S1 from "./subjects/DBMS/Module6/m6s1";
import DBMSM6S2 from "./subjects/DBMS/Module6/m6s2";
import DBMSM6S3 from "./subjects/DBMS/Module6/m6s3";
import DBMSM6S4 from "./subjects/DBMS/Module6/m6s4";
import DBMSM6S5 from "./subjects/DBMS/Module6/m6s5";
import DBMSM7S1 from "./subjects/DBMS/Module7/m7s1";








//OS imports
import OSM1S1 from "./subjects/OS/Module1/m1s1";
import OSM1S2 from "./subjects/OS/Module1/m1s2";
import OSM1S3 from "./subjects/OS/Module1/m1s3";

import OSM2S1 from "./subjects/OS/Module2/m2s1";
import OSM2S2 from "./subjects/OS/Module2/m2s2";
import OSM2S3 from "./subjects/OS/Module2/m2s3";
import OSM2S4 from "./subjects/OS/Module2/m2s4";

import OSM3S1 from "./subjects/OS/Module3/m3s1";
import OSM3S2 from "./subjects/OS/Module3/m3s2";
import OSM4S1 from "./subjects/OS/Module4/m4s1";
import OSM4S2 from "./subjects/OS/Module4/m4s2";
import OSM4S3 from "./subjects/OS/Module4/m4s3";
import OSM5S1 from "./subjects/OS/Module5/m5s1";
import OSM5S2 from "./subjects/OS/Module5/m5s2";
import OSM5S3 from "./subjects/OS/Module5/m5s3";
import OSM6S1 from "./subjects/OS/Module6/m6s1";
import OSM6S2 from "./subjects/OS/Module6/m6s2";
import OSM7S1 from "./subjects/OS/Module7/m7s1";
import OSM7S2 from "./subjects/OS/Module7/m7s2";





//CN imports
import CNM1S1 from "./subjects/CN/Module1/m1s1";
import CNM1S2 from "./subjects/CN/Module1/m1s2";
import CNM1S3 from "./subjects/CN/Module1/m1s3";
import CNM1S4 from "./subjects/CN/Module1/m1s4";

import CNM2S1 from "./subjects/CN/Module2/m2s1";
import CNM2S2 from "./subjects/CN/Module2/m2s2";

import CNM3S1 from "./subjects/CN/Module3/m3s1";

import CNM3S2 from "./subjects/CN/Module3/m3s2";
import CNM3S3 from "./subjects/CN/Module3/m3s3";
import CNM3S4 from "./subjects/CN/Module3/m3s4";
import CNM3S5 from "./subjects/CN/Module3/m3s5";

import CNM4S1 from "./subjects/CN/Module4/m4s1";
import CNM4S2 from "./subjects/CN/Module4/m4s2";
import CNM4S3 from "./subjects/CN/Module4/m4s3";

import CNM5S1 from "./subjects/CN/Module5/m5s1";
import CNM6S1 from "./subjects/CN/Module6/m6s1";
import CNM6S2 from "./subjects/CN/Module6/m6s2";

import CNM7S1 from "./subjects/CN/Module7/m7s1";

//SE imports
import SEM1S1 from "./subjects/SE/Module1/m1s1";
import SEM1S2 from "./subjects/SE/Module1/m1s2";
import SEM1S3 from "./subjects/SE/Module1/m1s3";
import SEM2S1 from "./subjects/SE/Module2/m2s1";
import SEM2S2 from "./subjects/SE/Module2/m2s2";
import SEM2S3 from "./subjects/SE/Module2/m2s3";
import SEM3S1 from "./subjects/SE/Module3/m3s1";
import SEM3S2 from "./subjects/SE/Module3/m3s2";
import SEM4S1 from "./subjects/SE/Module4/m4s1";
import SEM4S2 from "./subjects/SE/Module4/m4s2";
import SEM4S3 from "./subjects/SE/Module4/m4s3";
import SEM5S1 from "./subjects/SE/Module5/m5s1";
import SEM5S2 from "./subjects/SE/Module5/m5s2";
import SEM5S3 from "./subjects/SE/Module5/m5s3";



//CNS imports
import CNSM1S1 from "./subjects/CNS/Module1/m1s1";
import CNSM2S1 from "./subjects/CNS/Module2/m2s1";
import CNSM2S2 from "./subjects/CNS/Module2/m2s2";
import CNSM3S1 from "./subjects/CNS/Module3/m3s1";
import CNSM3S2 from "./subjects/CNS/Module3/m3s2";
import CNSM4S1 from "./subjects/CNS/Module4/m4s1";
import CNSM4S2 from "./subjects/CNS/Module4/m4s2";
import CNSM4S3 from "./subjects/CNS/Module4/m4s3";
import CNSM4S4 from "./subjects/CNS/Module4/m4s4";
import CNSM5S1 from "./subjects/CNS/Module5/m5s1";
import CNSM5S2 from "./subjects/CNS/Module5/m5s2";
import CNSM5S3 from "./subjects/CNS/Module5/m5s3";

//ES imports
import ESM1S1 from "./subjects/ES/Module1/m1s1";
import ESM1S2 from "./subjects/ES/Module1/m1s2";
import ESM2S1 from "./subjects/ES/Module2/m2s1";
import ESM2S2 from "./subjects/ES/Module2/m2s2";
import ESM2S3 from "./subjects/ES/Module2/m2s3";
import ESM4S1 from "./subjects/ES/Module4/m4s1";
import ESM5S1 from "./subjects/ES/Module5/m5s1";
import ESM5S2 from "./subjects/ES/Module5/m5s2";





//const TRACKING_ID = "G-R06ZJPZ7SK";
//ReactGA.initialize(TRACKING_ID);
//const TrackPageView = () => {
// const location = useLocation();
// useEffect(() => {
// ReactGA.send("pageview", { page_path: location.pathname });
// }, [location]);

// return null;
//};
// ✅ Google Analytics Setup
const ReviewPopup = ({ onClose }) => {
  return (
    <div className="review-popup-overlay">
      <div className="review-popup-content">
        <button className="review-close-btn" onClick={onClose}>×</button>

        <h3>VInTogether is now SemGuru</h3>

        <p>
          The same study material you've been using is now rebuilt and improved as SemGuru. Everything from VInTogether is already there, plus a lot that isn't. It is still completely free, with nothing to sign up for.
          <br /><br />
          Update your bookmarks to semguru.in. VInTogether will be discontinued soon, so please make the switch now.
        </p>

        <div className="review-popup-buttons">
          <button
            className="review-now-btn"
            onClick={() =>
              window.open(
                "https://semguru.in",
                "_blank"
              )
            }
          >
            Continue to SemGuru →
          </button>

          <button
            className="review-later-btn"
            onClick={onClose}
          >
            Maybe Later
          </button>
        </div>
      </div>
    </div>
  );
};
const TRACKING_ID = "G-BCXM6VJH3Q"; // Replace with your real Google Analytics ID
const setupGoogleAnalytics = () => {
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  gtag("js", new Date());
  gtag("config", TRACKING_ID);
};

export default function App() {
  const [showReviewPopup, setShowReviewPopup] = useState(false);

  useEffect(() => {
    // ✅ Load Google Analytics script dynamically
    document.title = "VinTogether";
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${TRACKING_ID}`;
    document.head.appendChild(script);
    script.onload = () => setupGoogleAnalytics();

    // Show review popup after 20 seconds on every page load
    const timer = setTimeout(() => {
      setShowReviewPopup(true);
    }, 20000); // 20 seconds

    return () => clearTimeout(timer);
  }, []);

  const closeReviewPopup = () => {
    setShowReviewPopup(false);
  };

  const handleReviewClick = () => {
    // Close the popup
    setShowReviewPopup(false);
    // Do not persist dismissal — popup should reappear on next load

    // Scroll to footer (assuming it has an id="review-section")
    setTimeout(() => {
      const reviewSection = document.getElementById('footer_section');
      if (reviewSection) {
        reviewSection.scrollIntoView({ behavior: 'smooth' });
      } else {
        // If not on homepage with Footer component, redirect to homepage with #review-section
        window.location.href = '/#footer_section';
      }
    }, 100);
  };

  return (
    <Router>
      <div id="top">
        {/* Review Popup */}
        {showReviewPopup && (
          <ReviewPopup
            onClose={closeReviewPopup}
            onReviewClick={handleReviewClick}
          />
        )}

        {/* Routes remain the same */}
        <Routes>
          <Route path="/" element={
            <>
              <HeaderHero />
              <SemguruSection />
              <CourseSection />
              <ContributeSection />
              <StatsSection />
              <AboutSection />
              <Footer />
            </>
          } />

          <Route path="/courses" element={
            <>
              <HeaderHero />
              <CoursesPage />
              <Footer />
            </>
          } />

          {/* subject Routes */}
          <Route path="/subject-CAOModules" element={<CAOModules />} />
          <Route path="/subject-DEModules" element={<DEModules />} />
          <Route path="/subject-OOPSModules" element={<OOPSModules />} />
          <Route path="/subject-DAAModules" element={<DAAModules />} />
          <Route path="/subject-TOCModules" element={<TOCModules />} />
          <Route path="/subject-MPMCModules" element={<MPMCModules />} />
          <Route path="/subject-BEEEModules" element={<BEEEModules />} />
          <Route path="/subject-ChemistryModules" element={<ChemistryModules />} />
          <Route path="/subject-CalculusModules" element={<CalculusModules />} />
          <Route path="/subject-DMModules" element={<DMModules />} />
          <Route path="/subject-CVLAModules" element={<CVLAModules />} />
          <Route path="/subject-DSDModules" element={<DSDModules />} />
          <Route path="/subject-CNModules" element={<CNModules />} />
          <Route path="/subject-DBMSModules" element={<DBMSModules />} />
          <Route path="/subject-OSModules" element={<OSModules />} />
          <Route path="/subject-AIModules" element={<AIModules />} />
          <Route path="/subject-CDModules" element={<CDModules />} />
          <Route path="/subject-DSAModules" element={<DSAModules />} />

          <Route path="/subject-SEModules" element={<SEModules />} />
          <Route path="/subject-CNSModules" element={<CNSModules />} />
          <Route path="/subject-ESModules" element={<ESModules />} />

          {/* OOPS routes */}
          <Route path="/oop-m1-s1" element={<OOPM1S1 />} />
          <Route path="/oop-m1-s2" element={<OOPM1S2 />} />
          <Route path="/oop-m1-s3" element={<OOPM1S3 />} />
          <Route path="/oop-m1-s4" element={<OOPM1S4 />} />
          <Route path="/oop-m1-s5" element={<OOPM1S5 />} />
          <Route path="/oop-m1-s6" element={<OOPM1S6 />} />
          <Route path="/oop-m1-s7" element={<OOPM1S7 />} />
          <Route path="/oop-m1-s8" element={<OOPM1S8 />} />

          <Route path="/oop-m2-s1" element={<OOPM2S1 />} />
          <Route path="/oop-m2-s2" element={<OOPM2S2 />} />
          <Route path="/oop-m2-s3" element={<OOPM2S3 />} />
          <Route path="/oop-m2-s4" element={<OOPM2S4 />} />
          <Route path="/oop-m2-s5" element={<OOPM2S5 />} />

          <Route path="/oop-m3-s1" element={<OOPM3S1 />} />
          <Route path="/oop-m3-s2" element={<OOPM3S2 />} />
          <Route path="/oop-m3-s3" element={<OOPM3S3 />} />
          <Route path="/oop-m3-s4" element={<OOPM3S4 />} />
          <Route path="/oop-m3-s5" element={<OOPM3S5 />} />

          <Route path="/oop-m4-s1" element={<OOPM4S1 />} />

          <Route path="/oop-m5-s1" element={<OOPM5S1 />} />
          <Route path="/oop-m5-s2" element={<OOPM5S2 />} />
          <Route path="/oop-m5-s3" element={<OOPM5S3 />} />
          <Route path="/oop-m5-s4" element={<OOPM5S4 />} />
          <Route path="/oop-m5-s5" element={<OOPM5S5 />} />
          <Route path="/oop-m5-s6" element={<OOPM5S6 />} />
          <Route path="/oop-m5-s7" element={<OOPM5S7 />} />

          <Route path="/oop-m6-s1" element={<OOPM6S1 />} />

          <Route path="/oop-m7-s1" element={<OOPM7S1 />} />
          <Route path="/oop-m7-s2" element={<OOPM7S2 />} />
          <Route path="/oop-m7-s3" element={<OOPM7S3 />} />

          <Route path="/oop-m8-s1" element={<OOPM8S1 />} />
          <Route path="/oop-m8-s2" element={<OOPM8S2 />} />


          {/*CAO routes*/}
          {/*M1*/}
          <Route path="/Ca-m1-s1" element={<M1s1 />} />
          <Route path="/Ca-m1-s2" element={<M1s2 />} />
          <Route path="/Ca-m1-s3" element={<M1s3 />} />
          <Route path="/Ca-m1-s4" element={<M1s4 />} />
          <Route path="/Ca-m1-s5" element={<M1s5 />} />
          <Route path="/Ca-m1-s6" element={<M1s6 />} />
          <Route path="/Ca-m1-s7" element={<M1s7 />} />
          {/*M2*/}
          <Route path="/Ca-m2-s1" element={<M2s1 />} />
          <Route path="/Ca-m2-s2" element={<M2s2 />} />
          <Route path="/Ca-m2-s3" element={<M2s3 />} />
          <Route path="/Ca-m2-s4" element={<M2s4 />} />
          {/*M3*/}
          <Route path="/Ca-m3-s1" element={<M3s1 />} />
          <Route path="/Ca-m3-s2" element={<ModuleSubtopicMemoryTraffic />} />
          <Route path="/Ca-m3-s3" element={<M3s3 />} />
          <Route path="/Ca-m3-s4" element={<M3s4 />} />
          <Route path="/Ca-m3-s5" element={<M3s5 />} />
          <Route path="/Ca-m3-s6" element={<M3s6 />} />
          <Route path="/Ca-m3-s7" element={<M3s7 />} />
          {/*M4*/}
          <Route path="/Ca-m4-s1" element={<M4s1 />} />
          <Route path="/Ca-m4-s2" element={<M4s2 />} />
          <Route path="/Ca-m4-s3" element={<M4s3 />} />
          <Route path="/Ca-m4-s4" element={<M4s4 />} />
          <Route path="/Ca-m4-s5" element={<ModuleSubtopicCacheManagement />} />
          <Route path="/Ca-m4-s6" element={<M4s6 />} />
          {/*M5*/}
          <Route path="/Ca-m5-s1" element={<M5s1 />} />
          <Route path="/Ca-m5-s2" element={<M5s2 />} />
          <Route path="/Ca-m5-s3" element={<M5s3 />} />
          <Route path="/Ca-m5-s4" element={<M5s4 />} />
          <Route path="/Ca-m5-s5" element={<M5s5 />} />
          <Route path="/Ca-m5-s6" element={<M5s6 />} />
          <Route path="/Ca-m5-s7" element={<M5s7 />} />
          {/*M6*/}
          <Route path="/Ca-m6-s1" element={<M6s1 />} />
          <Route path="/Ca-m6-s2" element={<M6s2 />} />
          <Route path="/Ca-m6-s3" element={<M6s3 />} />
          <Route path="/Ca-m6-s4" element={<M6s4 />} />
          {/*M7*/}
          <Route path="/Ca-m7-s1" element={<M7s1 />} />
          <Route path="/Ca-m7-s2" element={<M7s2 />} />
          <Route path="/Ca-m7-s3" element={<M7s3 />} />
          <Route path="/Ca-m7-s4" element={<M7s4 />} />
          <Route path="/Ca-m7-s5" element={<M7s5 />} />

          {/* DAA routes */}
          <Route path="/daa-m1-s1" element={<DAAM1S1 />} />
          <Route path="/daa-m1-s2" element={<DAAM1S2 />} />
          <Route path="/daa-m1-s3" element={<DAAM1S3 />} />
          <Route path="/daa-m1-s4" element={<DAAM1S4 />} />
          <Route path="/daa-m1-s5" element={<DAAM1S5 />} />

          <Route path="/daa-m2-s1" element={<DAAM2S1 />} />
          <Route path="/daa-m2-s2" element={<DAAM2S2 />} />
          <Route path="/daa-m2-s3" element={<DAAM2S3 />} />
          <Route path="/daa-m2-s4" element={<DAAM2S4 />} />
          <Route path="/daa-m2-s5" element={<DAAM2S5 />} />
          <Route path="/daa-m2-s6" element={<DAAM2S6 />} />
          <Route path="/daa-m2-s7" element={<DAAM2S7 />} />
          <Route path="/daa-m2-s8" element={<DAAM2S8 />} />
          <Route path="/daa-m2-s9" element={<DAAM2S9 />} />

          <Route path="/daa-m3-s1" element={<DAAM3S1 />} />
          <Route path="/daa-m3-s2" element={<DAAM3S2 />} />
          <Route path="/daa-m3-s3" element={<DAAM3S3 />} />

          <Route path="/daa-m4-s1" element={<DAAM4S1 />} />
          <Route path="/daa-m4-s2" element={<DAAM4S2 />} />
          <Route path="/daa-m4-s3" element={<DAAM4S3 />} />
          <Route path="/daa-m4-s4" element={<DAAM4S4 />} />
          <Route path="/daa-m4-s5" element={<DAAM4S5 />} />

          <Route path="/daa-m5-s1" element={<DAAM5S1 />} />
          <Route path="/daa-m5-s2" element={<DAAM5S2 />} />
          <Route path="/daa-m5-s3" element={<DAAM5S3 />} />

          <Route path="/daa-m6-s1" element={<DAAM6S1 />} />
          <Route path="/daa-m6-s2" element={<DAAM6S2 />} />
          <Route path="/daa-m6-s3" element={<DAAM6S3 />} />

          {/* TOC routes */}
          <Route path="/TOC-ProofTechniques" element={<ModuleSubtopicProofTechniques />} />
          <Route path="/TOC-Languages" element={<ModuleSubtopicLanguagesGrammar />} />
          <Route path="/TOC-Alphabets" element={<ModuleSubtopicAlphabetsStrings />} />
          <Route path="/TOCMO1-Summary" element={<ModuleSummaryTOC />} />
          <Route path="/TOC-FiniteAutomata" element={<ModuleSubtopicFiniteAutomata />} />
          <Route path="/TOC-NFA" element={<ModuleSubtopicNFA />} />
          <Route path="/TOC-DFA" element={<ModuleSubtopicDFA />} />
          <Route path="/TOC-NFAConversion" element={<ModuleSubtopicNFAConversion />} />
          <Route path="/TOC-NFAtoDFA" element={<ModuleSubtopicNFAtoDFA />} />
          <Route path="/TOC-MinimizationDFA" element={<ModuleSubtopicMinimizationDFA />} />
          <Route path="/TOC-ModuleSummary" element={<ModuleSummary2TOC />} />
          <Route path="/TOC-RegularExpressions" element={<ModuleSubtopicRegularExpressions />} />
          <Route path="/TOC-FAtoRE" element={<ModuleSubtopicFAtoRE />} />
          <Route path="/TOC-REtoFA" element={<ModuleSubtopicREtoFA />} />
          <Route path="/TOC-PumpingLemma" element={<ModuleSubtopicPumpingLemma />} />
          <Route path="/TOC-CFG" element={<ModuleSubtopicCFG />} />
          <Route path="/TOC-Derivations" element={<ModuleSubtopicDerivations />} />
          <Route path="/TOC-CYK" element={<ModuleSubtopicCYK />} />
          <Route path="/TOC-SimplificationCFG" element={<ModuleSubtopicSimplificationCFG />} />
          <Route path="/TOC-NormalFormsCFG" element={<ModuleSubtopicNormalFormsCFG />} />
          <Route path="/TOC-PumpingLemmaCFL" element={<ModuleSubtopicPumpingLemmaCFL />} />
          <Route path="/TOC-ClosurePropertiesCFL" element={<ModuleSubtopicClosurePropertiesCFL />} />
          <Route path="/TOC-PDA" element={<ModuleSubtopicPDA />} />
          {/*<Route path="/TOC-NPDA-DPDA" element={<TOCM5S1 />} /> */}




          {/* MPMC routes */}
          <Route path="/mpmc-m1-s1" element={<MPMCM1S1 />} />

          <Route path="/mpmc-m3-s1" element={<MPMCM3S1 />} />
          <Route path="/mpmc-m3-s2" element={<MPMCM3S2 />} />
          <Route path="/mpmc-m3-s3" element={<MPMCM3S3 />} />
          <Route path="/mpmc-m3-s4" element={<MPMCM3S4 />} />
          <Route path="/mpmc-m3-s5" element={<MPMCM3S5 />} />
          <Route path="/mpmc-m3-s6" element={<MPMCM3S6 />} />
          <Route path="/mpmc-m3-s7" element={<MPMCM3S7 />} />
          <Route path="/mpmc-m3-s8" element={<MPMCM3S8 />} />
          <Route path="/mpmc-m3-s9" element={<MPMCM3S9 />} />

          <Route path="/mpmc-m4-s1" element={<MPMCM4S1 />} />
          <Route path="/mpmc-m4-s2" element={<MPMCM4S2 />} />
          <Route path="/mpmc-m4-s3" element={<MPMCM4S3 />} />
          <Route path="/mpmc-m4-s4" element={<MPMCM4S4 />} />

          <Route path="/mpmc-m5-s1" element={<MPMCM5S1 />} />
          <Route path="/mpmc-m5-s2" element={<MPMCM5S2 />} />
          <Route path="/mpmc-m5-s3" element={<MPMCM5S3 />} />
          <Route path="/mpmc-m5-s4" element={<MPMCM5S4 />} />

          <Route path="/mpmc-m6-s1" element={<MPMCM6S1 />} />

          <Route path="/mpmc-m7-s1" element={<MPMCM7S1 />} />



          {/*DE routers*/}
          {/*M1*/}
          <Route path="/de-m1-s1" element={<M1S1 />} />
          <Route path="/de-m1-s2" element={<M1S2 />} />
          <Route path="/de-m1-s3" element={<M1S3 />} />
          <Route path="/de-m1-s4" element={<M1S4 />} />
          <Route path="/de-m1-s5" element={<M1S5 />} />
          <Route path="/de-m1-s6" element={<M1S6 />} />

          {/*M2*/}
          <Route path="/de-m2-s1" element={<M2S1 />} />
          <Route path="/de-m2-s2" element={<M2S2 />} />
          <Route path="/de-m2-s3" element={<M2S3 />} />
          <Route path="/de-m2-s4" element={<M2S4 />} />
          <Route path="/de-m2-s5" element={<M2S5 />} />
          {/*M3*/}
          <Route path="/de-m3-s1" element={<M3S1 />} />
          <Route path="/de-m3-s2" element={<M3S2 />} />
          <Route path="/de-m3-s3" element={<M3S3 />} />
          <Route path="/de-m3-s4" element={<M3S4 />} />
          <Route path="/de-m3-s5" element={<M3S5 />} />
          {/*M4*/}
          <Route path="/de-m4-s1" element={<M4S1 />} />
          <Route path="/de-m4-s2" element={<M4S2 />} />
          <Route path="/de-m4-s3" element={<M4S3 />} />
          {/*M5*/}
          <Route path="/de-m5-s1" element={<M5S1 />} />
          <Route path="/de-m5-s2" element={<M5S2 />} />
          <Route path="/de-m5-s3" element={<M5S3 />} />
          <Route path="/de-m5-s4" element={<M5S4 />} />
          <Route path="/de-m5-s5" element={<M5S5 />} />
          {/*M6*/}
          <Route path="/de-m6-s1" element={<M6S1 />} />
          <Route path="/de-m6-s2" element={<M6S2 />} />
          <Route path="/de-m6-s3" element={<M6S3 />} />
          <Route path="/de-m6-s4" element={<M6S4 />} />
          <Route path="/de-m6-s5" element={<M6S5 />} />
          <Route path="/de-m6-s6" element={<M6S6 />} />
          {/*M7*/}
          <Route path="/de-m7-s1" element={<M7S1 />} />
          <Route path="/de-m7-s2" element={<M7S2 />} />
          <Route path="/de-m7-s3" element={<M7S3 />} />
          <Route path="/de-m7-s4" element={<M7S4 />} />




          {/*CD routes*/}
          <Route path="/cd-m1-s1" element={<CDM1S1 />} />
          <Route path="/cd-m1-s2" element={<CDM1S2 />} />
          <Route path="/cd-m1-s3" element={<CDM1S3 />} />
          <Route path="/cd-m1-s4" element={<CDM1S4 />} />
          <Route path="/cd-m2-s1" element={<CDM2S1 />} />
          <Route path="/cd-m2-s2" element={<CDM2S2 />} />
          <Route path="/cd-m2-s3" element={<CDM2S3 />} />
          <Route path="/cd-m2-s4" element={<CDM2S4 />} />
          <Route path="/cd-m2-s5" element={<CDM2S5 />} />
          <Route path="/cd-m2-s6" element={<CDM2S6 />} />
          <Route path="/cd-m2-s7" element={<CDM2S7 />} />
          <Route path="/cd-m2-s8" element={<CDM2S8 />} />
          <Route path="/cd-m2-s9" element={<CDM2S9 />} />
          <Route path="/cd-m3-s1" element={<CDM3S1 />} />
          <Route path="/cd-m3-s2" element={<CDM3S2 />} />
          <Route path="/cd-m4-s1" element={<CDM4S1 />} />
          <Route path="/cd-m4-s2" element={<CDM4S2 />} />
          <Route path="/cd-m5-s1" element={<CDM5S1 />} />
          <Route path="/cd-m5-s2" element={<CDM5S2 />} />
          <Route path="/cd-m5-s3" element={<CDM5S3 />} />
          <Route path="/cd-m6-s1" element={<CDM6S1 />} />
          <Route path="/cd-m6-s2" element={<CDM6S2 />} />
          <Route path="/cd-m6-s3" element={<CDM6S3 />} />
          <Route path="/cd-m6-s4" element={<CDM6S4 />} />
          <Route path="/cd-m7-s1" element={<CDM7S1 />} />
          <Route path="/cd-m7-s2" element={<CDM7S2 />} />


          {/*CH routes*/}
          <Route path="/ch-m1-s1" element={<CHM1S1 />} />
          <Route path="/ch-m1-s2" element={<CHM1S2 />} />
          <Route path="/ch-m1-s3" element={<CHM1S3 />} />
          <Route path="/ch-m2-s1" element={<CHM2S1 />} />
          <Route path="/ch-m2-s2" element={<CHM2S2 />} />
          <Route path="/ch-m3-s1" element={<CHM3S1 />} />
          <Route path="/ch-m3-s2" element={<CHM3S2 />} />
          <Route path="/ch-m4-s1" element={<CHM4S1 />} />
          <Route path="/ch-m4-s2" element={<CHM4S2 />} />
          <Route path="/ch-m5-s1" element={<CHM5S1 />} />
          <Route path="/ch-m5-s2" element={<CHM5S2 />} />
          <Route path="/ch-m6-s1" element={<CHM6S1 />} />
          <Route path="/ch-m7-s1" element={<CHM7S1 />} />
          <Route path="/ch-m7-s2" element={<CHM7S2 />} />
          <Route path="/ch-m7-s3" element={<CHM7S3 />} />


          {/*AI routes*/}
          <Route path="/ai-m1-s1" element={<AIM1S1 />} />
          <Route path="/ai-m1-s2" element={<AIM1S2 />} />
          <Route path="/ai-m1-s3" element={<AIM1S3 />} />
          <Route path="/ai-m2-s1" element={<AIM2S1 />} />
          <Route path="/ai-m2-s2" element={<AIM2S2 />} />
          <Route path="/ai-m2-s3" element={<AIM2S3 />} />
          <Route path="/ai-m3-s1" element={<AIM3S1 />} />
          <Route path="/ai-m3-s2" element={<AIM3S2 />} />
          <Route path="/ai-m3-s3" element={<AIM3S3 />} />
          <Route path="/ai-m4-s1" element={<AIM4S1 />} />
          <Route path="/ai-m4-s2" element={<AIM4S2 />} />
          <Route path="/ai-m4-s3" element={<AIM4S3 />} />
          <Route path="/ai-m5-s1" element={<AIM5S1 />} />
          <Route path="/ai-m5-s2" element={<AIM5S2 />} />
          <Route path="/ai-m6-s1" element={<AIM6S1 />} />
          <Route path="/ai-m6-s2" element={<AIM6S2 />} />
          <Route path="/ai-m6-s3" element={<AIM6S3 />} />
          <Route path="/ai-m6-s4" element={<AIM6S4 />} />
          <Route path="/ai-m7-s1" element={<AIM7S1 />} />
          <Route path="/ai-m7-s2" element={<AIM7S2 />} />
          <Route path="/ai-m7-s3" element={<AIM7S3 />} />

          {/*DSD routes*/}
          <Route path="/dsd-m1-s1" element={<DSDM1S1 />} />
          <Route path="/dsd-m1-s2" element={<DSDM1S2 />} />
          <Route path="/dsd-m1-s3" element={<DSDM1S3 />} />
          <Route path="/dsd-m1-s4" element={<DSDM1S4 />} />
          <Route path="/dsd-m1-s5" element={<DSDM1S5 />} />
          <Route path="/dsd-m2-s1" element={<DSDM2S1 />} />
          <Route path="/dsd-m3-s1" element={<DSDM3S1 />} />
          <Route path="/dsd-m3-s2" element={<DSDM3S2 />} />
          <Route path="/dsd-m3-s3" element={<DSDM3S3 />} />
          <Route path="/dsd-m3-s4" element={<DSDM3S4 />} />
          <Route path="/dsd-mc-s1" element={<DSDMCS1 />} />
          <Route path="/dsd-mc-s2" element={<DSDMCS2 />} />
          <Route path="/dsd-mc-s3" element={<DSDMCS3 />} />
          <Route path="/dsd-mc-s4" element={<DSDMCS4 />} />
          <Route path="/dsd-mc-s5" element={<DSDMCS5 />} />
          <Route path="/dsd-mc-s6" element={<DSDMCS6 />} />
          <Route path="/dsd-mc-s7" element={<DSDMCS7 />} />
          <Route path="/dsd-mc-s8" element={<DSDMCS8 />} />
          <Route path="/dsd-mc-s9" element={<DSDMCS9 />} />
          <Route path="/dsd-m6-s1" element={<DSDM6S1 />} />
          <Route path="/dsd-m7-s1" element={<DSDM7S1 />} />



          {/*BEEE routes*/}
          <Route path="/beee-m1-s1" element={<BEEEM1S1 />} />
          <Route path="/beee-m1-s2" element={<BEEEM1S2 />} />
          <Route path="/beee-m1-s3" element={<BEEEM1S3 />} />
          <Route path="/beee-m2-s1" element={<BEEEM2S1 />} />
          <Route path="/beee-m3-s1" element={<BEEEM3S1 />} />
          <Route path="/beee-m3-s2" element={<BEEEM3S2 />} />
          <Route path="/beee-m4-s1" element={<BEEEM4S1 />} />
          <Route path="/beee-m5-s1" element={<BEEEM5S1 />} />
          <Route path="/beee-m5-s2" element={<BEEEM5S2 />} />
          <Route path="/beee-m6-s1" element={<BEEEM6S1 />} />

          {/* Calculus routes*/}
          <Route path="/cal-m1-s1" element={<CALM1S1 />} />
          <Route path="/cal-m1-s2" element={<CALM1S2 />} />
          <Route path="/cal-m1-s3" element={<CALM1S3 />} />
          <Route path="/cal-m2-s1" element={<CALM2S1 />} />
          <Route path="/cal-m2-s2" element={<CALM2S2 />} />
          <Route path="/cal-m2-s3" element={<CALM2S3 />} />
          <Route path="/cal-m3-s1" element={<CALM3S1 />} />
          <Route path="/cal-m3-s2" element={<CALM3S2 />} />
          <Route path="/cal-m3-s3" element={<CALM3S3 />} />
          <Route path="/cal-m4-s1" element={<CALM4S1 />} />
          <Route path="/cal-m4-s2" element={<CALM4S2 />} />
          <Route path="/cal-m4-s3" element={<CALM4S3 />} />
          <Route path="/cal-m4-s4" element={<CALM4S4 />} />
          <Route path="/cal-m4-s5" element={<CALM4S5 />} />
          <Route path="/cal-m4-s6" element={<CALM4S6 />} />
          <Route path="/cal-m5-s1" element={<CALM5S1 />} />
          <Route path="/cal-m5-s2" element={<CALM5S2 />} />
          <Route path="/cal-m5-s3" element={<CALM5S3 />} />
          <Route path="/cal-m6-s1" element={<CALM6S1 />} />
          <Route path="/cal-m6-s2" element={<CALM6S2 />} />
          <Route path="/cal-m6-s3" element={<CALM6S3 />} />
          <Route path="/cal-m6-s4" element={<CALM6S4 />} />
          <Route path="/cal-m7-s1" element={<CALM7S1 />} />
          <Route path="/cal-m7-s2" element={<CALM7S2 />} />
          <Route path="/cal-m7-s3" element={<CALM7S3 />} />
          <Route path="/cal-m7-s4" element={<CALM7S4 />} />
          <Route path="/cal-m7-s5" element={<CALM7S5 />} />


          {/*DM*/}
          <Route path="/dm-m1-s1" element={<DM1S1 />} />
          <Route path="/dm-m1-s2" element={<DM1S2 />} />
          <Route path="/dm-m1-s3" element={<DM1S3 />} />
          <Route path="/dm-m2-s1" element={<DM2S1 />} />
          <Route path="/dm-m3-s1" element={<DM3S1 />} />
          <Route path="/dm-m3-s2" element={<DM3S2 />} />
          <Route path="/dm-m3-s3" element={<DM3S3 />} />
          <Route path="/dm-m3-s4" element={<DM3S4 />} />
          <Route path="/dm-m4-s1" element={<DM4S1 />} />
          <Route path="/dm-m4-s2" element={<DM4S2 />} />
          <Route path="/dm-m4-s3" element={<DM4S3 />} />
          <Route path="/dm-m4-s4" element={<DM4S4 />} />
          <Route path="/dm-m5-s1" element={<DM5S1 />} />
          <Route path="/dm-m5-s2" element={<DM5S2 />} />
          <Route path="/dm-m5-s3" element={<DM5S3 />} />
          <Route path="/dm-m5-s4" element={<DM5S4 />} />
          <Route path="/dm-m5-s5" element={<DM5S5 />} />
          <Route path="/dm-m5-s6" element={<DM5S6 />} />
          <Route path="/dm-m6-s1" element={<DM6S1 />} />
          <Route path="/dm-m6-s2" element={<DM6S2 />} />
          <Route path="/dm-m6-s3" element={<DM6S3 />} />
          <Route path="/dm-m7-s1" element={<DM7S1 />} />






          {/*DSA*/}
          <Route path="/dsa-m1-s1" element={<DSAM1S1 />} />
          <Route path="/dsa-m1-s2" element={<DSAM1S2 />} />
          <Route path="/dsa-m1-s3" element={<DSAM1S3 />} />
          <Route path="/dsa-m1-s4" element={<DSAM1S4 />} />
          <Route path="/dsa-m1-s5" element={<DSAM1S5 />} />
          <Route path="/dsa-m2-s1" element={<DSAM2S1 />} />
          <Route path="/dsa-m2-s2" element={<DSAM2S2 />} />
          <Route path="/dsa-m2-s3" element={<DSAM2S3 />} />
          <Route path="/dsa-m2-s4" element={<DSAM2S4 />} />
          <Route path="/dsa-m2-s5" element={<DSAM2S5 />} />
          <Route path="/dsa-m3-s1" element={<DSAM3S1 />} />
          <Route path="/dsa-m3-s2" element={<DSAM3S2 />} />
          <Route path="/dsa-m3-s3" element={<DSAM3S3 />} />
          <Route path="/dsa-m3-s4" element={<DSAM3S4 />} />
          <Route path="/dsa-m3-s5" element={<DSAM3S5 />} />
          <Route path="/dsa-m4-s1" element={<DSAM4S1 />} />
          <Route path="/dsa-m4-s2" element={<DSAM4S2 />} />
          <Route path="/dsa-m5-s1" element={<DSAM5S1 />} />
          <Route path="/dsa-m5-s2" element={<DSAM5S2 />} />
          <Route path="/dsa-m6-s1" element={<DSAM6S1 />} />
          <Route path="/dsa-m6-s2" element={<DSAM6S2 />} />
          <Route path="/dsa-m7-s1" element={<DSAM7S1 />} />


          {/*CVLA*/}
          <Route path="/cvla-m1-s1" element={<CVLAM1S1 />} />
          <Route path="/cvla-m1-s2" element={<CVLAM1S2 />} />
          <Route path="/cvla-m1-s3" element={<CVLAM1S3 />} />
          <Route path="/cvla-m1-s4" element={<CVLAM1S4 />} />
          <Route path="/cvla-m1-s5" element={<CVLAM1S5 />} />
          <Route path="/cvla-m2-s1" element={<CVLAM2S1 />} />
          <Route path="/cvla-m2-s2" element={<CVLAM2S2 />} />
          <Route path="/cvla-m2-s3" element={<CVLAM2S3 />} />
          <Route path="/cvla-m3-s1" element={<CVLAM3S1 />} />
          <Route path="/cvla-m3-s2" element={<CVLAM3S2 />} />
          <Route path="/cvla-m3-s3" element={<CVLAM3S3 />} />
          <Route path="/cvla-m3-s4" element={<CVLAM3S4 />} />
          <Route path="/cvla-m3-s5" element={<CVLAM3S5 />} />
          <Route path="/cvla-m3-s6" element={<CVLAM3S6 />} />
          <Route path="/cvla-m4-s1" element={<CVLAM4S1 />} />
          <Route path="/cvla-m4-s2" element={<CVLAM4S2 />} />
          <Route path="/cvla-m7-s1" element={<CVLAM7S1 />} />
          <Route path="/cvla-m7-s2" element={<CVLAM7S2 />} />
          <Route path="/cvla-m7-s3" element={<CVLAM7S3 />} />
          <Route path="/cvla-m5-s1" element={<CVLAM5S1 />} />
          <Route path="/cvla-m5-s2" element={<CVLAM5S2 />} />
          <Route path="/cvla-m5-s3" element={<CVLAM5S3 />} />
          <Route path="/cvla-m6-s1" element={<CVLAM6S1 />} />



          {/*DBMS*/}
          <Route path="/dbms-m1-s1" element={<DBMSM1S1 />} />
          <Route path="/dbms-m2-s1" element={<DBMSM2S1 />} />
          <Route path="/dbms-m2-s2" element={<DBMSM2S2 />} />
          <Route path="/dbms-m2-s3" element={<DBMSM2S3 />} />
          <Route path="/dbms-m2-s4" element={<DBMSM2S4 />} />
          <Route path="/dbms-m3-s1" element={<DBMSM3S1 />} />
          <Route path="/dbms-m3-s2" element={<DBMSM3S2 />} />
          <Route path="/dbms-m3-s3" element={<DBMSM3S3 />} />
          <Route path="/dbms-m4-s1" element={<DBMSM4S1 />} />
          <Route path="/dbms-m4-s2" element={<DBMSM4S2 />} />
          <Route path="/dbms-m4-s3" element={<DBMSM4S3 />} />
          <Route path="/dbms-m4-s4" element={<DBMSM4S4 />} />
          <Route path="/dbms-m4-s5" element={<DBMSM4S5 />} />
          <Route path="/dbms-m5-s1" element={<DBMSM5S1 />} />
          <Route path="/dbms-m5-s2" element={<DBMSM5S2 />} />
          <Route path="/dbms-m5-s3" element={<DBMSM5S3 />} />
          <Route path="/dbms-m5-s4" element={<DBMSM5S4 />} />
          <Route path="/dbms-m6-s1" element={<DBMSM6S1 />} />
          <Route path="/dbms-m6-s2" element={<DBMSM6S2 />} />
          <Route path="/dbms-m6-s3" element={<DBMSM6S3 />} />
          <Route path="/dbms-m6-s4" element={<DBMSM6S4 />} />
          <Route path="/dbms-m6-s5" element={<DBMSM6S5 />} />
          <Route path="/dbms-m7-s1" element={<DBMSM7S1 />} />



          {/*OS*/}
          <Route path="/os-m1-s1" element={<OSM1S1 />} />
          <Route path="/os-m1-s2" element={<OSM1S2 />} />
          <Route path="/os-m1-s3" element={<OSM1S3 />} />
          <Route path="/os-m2-s1" element={<OSM2S1 />} />
          <Route path="/os-m2-s2" element={<OSM2S2 />} />
          <Route path="/os-m2-s3" element={<OSM2S3 />} />
          <Route path="/os-m2-s4" element={<OSM2S4 />} />
          <Route path="/os-m3-s1" element={<OSM3S1 />} />
          <Route path="/os-m3-s2" element={<OSM3S2 />} />
          <Route path="/os-m4-s1" element={<OSM4S1 />} />
          <Route path="/os-m4-s2" element={<OSM4S2 />} />
          <Route path="/os-m4-s3" element={<OSM4S3 />} />
          <Route path="/os-m5-s1" element={<OSM5S1 />} />
          <Route path="/os-m5-s2" element={<OSM5S2 />} />
          <Route path="/os-m5-s3" element={<OSM5S3 />} />
          <Route path="/os-m6-s1" element={<OSM6S1 />} />
          <Route path="/os-m6-s2" element={<OSM6S2 />} />
          <Route path="/os-m7-s1" element={<OSM7S1 />} />
          <Route path="/os-m7-s2" element={<OSM7S2 />} />





          {/*CN*/}
          <Route path="/cn-m1-s1" element={<CNM1S1 />} />
          <Route path="/cn-m1-s2" element={<CNM1S2 />} />
          <Route path="/cn-m1-s3" element={<CNM1S3 />} />
          <Route path="/cn-m1-s4" element={<CNM1S4 />} />
          <Route path="/cn-m2-s1" element={<CNM2S1 />} />
          <Route path="/cn-m2-s2" element={<CNM2S2 />} />
          <Route path="/cn-m3-s1" element={<CNM3S1 />} />
          <Route path="/cn-m3-s2" element={<CNM3S2 />} />
          <Route path="/cn-m3-s3" element={<CNM3S3 />} />
          <Route path="/cn-m3-s4" element={<CNM3S4 />} />
          <Route path="/cn-m3-s5" element={<CNM3S5 />} />
          <Route path="/cn-m4-s1" element={<CNM4S1 />} />
          <Route path="/cn-m4-s2" element={<CNM4S2 />} />
          <Route path="/cn-m4-s3" element={<CNM4S3 />} />
          <Route path="/cn-m5-s1" element={<CNM5S1 />} />
          <Route path="/cn-m6-s1" element={<CNM6S1 />} />
          <Route path="/cn-m6-s2" element={<CNM6S2 />} />
          <Route path="/cn-m7-s1" element={<CNM7S1 />} />

          {/*SE*/}
          <Route path="/se-m1-s1" element={<SEM1S1 />} />
          <Route path="/se-m1-s2" element={<SEM1S2 />} />
          <Route path="/se-m1-s3" element={<SEM1S3 />} />
          <Route path="/se-m2-s1" element={<SEM2S1 />} />
          <Route path="/se-m2-s2" element={<SEM2S2 />} />
          <Route path="/se-m2-s3" element={<SEM2S3 />} />
          <Route path="/se-m3-s1" element={<SEM3S1 />} />
          <Route path="/se-m3-s2" element={<SEM3S2 />} />
          <Route path="/se-m4-s1" element={<SEM4S1 />} />
          <Route path="/se-m4-s2" element={<SEM4S2 />} />
          <Route path="/se-m4-s3" element={<SEM4S3 />} />
          <Route path="/se-m5-s1" element={<SEM5S1 />} />
          <Route path="/se-m5-s2" element={<SEM5S2 />} />
          <Route path="/se-m5-s3" element={<SEM5S3 />} />



          {/*CNS*/}
          <Route path="/cns-m1-s1" element={<CNSM1S1 />} />
          <Route path="/cns-m2-s1" element={<CNSM2S1 />} />
          <Route path="/cns-m2-s2" element={<CNSM2S2 />} />
          <Route path="/cns-m3-s1" element={<CNSM3S1 />} />
          <Route path="/cns-m3-s2" element={<CNSM3S2 />} />
          <Route path="/cns-m4-s1" element={<CNSM4S1 />} />
          <Route path="/cns-m4-s2" element={<CNSM4S2 />} />
          <Route path="/cns-m4-s3" element={<CNSM4S3 />} />
          <Route path="/cns-m4-s4" element={<CNSM4S4 />} />
          <Route path="/cns-m5-s1" element={<CNSM5S1 />} />
          <Route path="/cns-m5-s2" element={<CNSM5S2 />} />
          <Route path="/cns-m5-s3" element={<CNSM5S3 />} />



          {/*ES*/}
          <Route path="/es-m1-s1" element={<ESM1S1 />} />
          <Route path="/es-m1-s2" element={<ESM1S2 />} />
          <Route path="/es-m2-s1" element={<ESM2S1 />} />
          <Route path="/es-m2-s2" element={<ESM2S2 />} />
          <Route path="/es-m2-s3" element={<ESM2S3 />} />
          <Route path="/es-m4-s1" element={<ESM4S1 />} />
          <Route path="/es-m5-s1" element={<ESM5S1 />} />
          <Route path="/es-m5-s2" element={<ESM5S2 />} />






















        </Routes>
      </div>
    </Router>
  );
}
